'use strict'

/**
 * マトリクスで最も重い計算（statusByCode の事前計算 = 大きな mappingList の全走査）を 1 つの純粋関数にまとめたモジュール。 Web Worker とメインスレッド（Worker
 * 非対応環境のフォールバック）の双方から同じ関数を呼ぶことで、 計算ロジックが二重化して挙動が乖離するのを防ぐ（テスト済みの buildStatusByCode をそのまま使う）。
 *
 * 設計方針（コードレビュー反映）: statusByCode は (allColumnCodes / mappingList / mappingListMonthly / periodKind) のみに依存し、
 * モード・検索・行フィルタには依存しない。 そのためこの「重い・参照を安定させたい」計算だけを Worker に切り出し、 列フィルタ・行フィルタ・サマリ（軽量で粒度の細かいメモ化が効く）はメインスレッドの useMemo に残す。
 *
 * 入力・出力はすべて構造化複製（structured clone）可能なプレーンオブジェクト/配列のみ（Map / Set / 関数を含めない）。
 */

import { buildStatusByCode } from './helpers'

/**
 * @typedef {object} StatusByCodeInput
 * @property {string[]} allColumnCodes - StatusByCode を組み立てる対象の全列コード
 * @property {object[]} mappingList - 汎用マッピング一覧（主）
 * @property {object[]} mappingListMonthly - 月次参照用マッピング一覧
 * @property {string} periodKind - 集計期間種別（月次 / 四半期 / 年次）
 */

/**
 * 列コード→マッピング状態の事前計算（Worker・フォールバック双方の単一の真実の源）。
 *
 * @param {StatusByCodeInput} input
 * @returns {{ [code: string]: 'set' | 'unset' | 'remove' }}
 */
export function computeStatusByCode(input) {
  const { allColumnCodes, mappingList, mappingListMonthly, periodKind } = input
  return buildStatusByCode(allColumnCodes, mappingList, mappingListMonthly, periodKind)
}

/** Worker 応答前・マッピング未取得時に使う空の statusByCode（共有シングルトン。書き換え禁止のため凍結）。 */
export const EMPTY_STATUS_BY_CODE = Object.freeze({})
